/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import type { JSX } from "react"
import { Link } from "react-router"

import type { AppRoutes } from "../../routes/routes"

interface Props {
    to: AppRoutes
    title: string
    iconPath: string
    css: string
}

export const SidebarLinkView = ({ to, title, iconPath, css }: Props): JSX.Element => (
    <li className="nav-item">
        <Link to={to} className={`nav-link ${css}`}>
            <img src={iconPath} className="mb-1" alt={title} />
            <span className="ms-legacy">{title}</span>
        </Link>
    </li>
)
